import React, { useState, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { editLock } from "actions/Units";
import SelectInput from "components/SelectInput";
import ButtonContained from "components/ButtonContained";
import LoadingIndicator from "components/LoadingIndicator";

const LockSettingsLocationModal = ({ lock, unitUUID }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  
  const fetchedLock = useSelector(state => state.units.unitObject?.unit?.locks.find(l => l.id === lock.id));
  const [localLock, setLocalLock] = useState(null);
  const originalLock = useRef(null);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    if (fetchedLock) {
      setLocalLock(fetchedLock);
      originalLock.current = fetchedLock;
    }
  }, [fetchedLock]);

  useEffect(() => {
    if (localLock && originalLock.current) {
      const isChanged = localLock.installLocation !== originalLock.current.installLocation;
      setHasChanges(isChanged);
    }
  }, [localLock]);

  const handleInputChange = (field, value) => {
    setLocalLock((prevLock) => ({
      ...prevLock,
      [field]: value,
    }));
  };

  return (
    localLock ? <div className="min-h-[300px] px-10 pt-4 flex flex-col justify-between gap-8">
      <div>
        <SelectInput
          id="Lock-Settings-Location-Input"
          dataCy="Lock-Settings-Location-Input"
          value={localLock?.installLocation ?? ""}
          placeholder={intl.formatMessage({ id: "form.installLocation" })}
          onChange={(e) => handleInputChange("installLocation", e.target.value)}
          options={[
            {
                name: intl.formatMessage({ id: 'db.unknown' }),
                value: 'unknown'
            },
            {
                name: intl.formatMessage({ id: 'form.indoor' }),
                value: 'indoor'
            },
            {
                name: intl.formatMessage({ id: 'form.outdoor' }),
                value: 'outdoor'
            },
            {
                name: intl.formatMessage({ id: 'form.indoorClimateControl' }),
                value: 'indoor_climate_control'
            }
          ]}
        />
      </div>
      <div>
        <ButtonContained
          id="Lock-Settings-Location-Save-Changes-Button"
          dataCy="Lock-Settings-Location-Save-Changes-Button"
          text={intl.formatMessage({ id: "comp.button.saveChanges" })}
          type="default"
          disabled={!hasChanges}
          onClick={() => dispatch(
            editLock(
              {
                ...localLock,
                unitUUID: unitUUID,
                lockId: localLock.id,
                lockUUID: localLock.uuid
              },
              {
                success: intl.formatMessage({ id: "notifications.success.edit" }),
                refetch: true,
              }
            )
          )}
        />
      </div>
    </div> : <div className="min-h-[300px] flex justify-center">
      <LoadingIndicator />
    </div>
  )
};

export default LockSettingsLocationModal;